import { Paper, Typography } from "@mui/material"

interface InfoSquareProps {
    titulo: string,
    dado: number
}

export const InfoSquare: React.FC<InfoSquareProps> = ({titulo, dado}) => {
    return (
        <Paper sx={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center", 
            justifyContent: "center", 
            gap: 1, 
            p: 2, 
            width: "100%", 
            height: "100%" }}
        >
            <Typography fontSize={{ xs: 18, sm: 22, md: 24 }}>{dado}</Typography>
            <Typography fontSize={12}>{titulo}</Typography>
        </Paper>
    )
}